import { Outlet } from 'react-router-dom';

import './AuthForm.css';

/**
 * AuthForm component view
 * @returns
 */
export default function AuthForm() {
    return <Outlet />;
}
